/** @format */

import React from 'react';
import { PasswordResetContainer } from 'features/auth';

const PasswordResetPage: React.FC = () => {
  return <PasswordResetContainer />;
};

export default PasswordResetPage;
